module.exports = __webpack_public_path__ + "media/images/LibraryCatalogue-8b34d1a1d6591acefc1b6ebf19f4dde3.svg";